import { useEffect, useRef, useState } from 'react';

/**
 * Hook to detect scroll direction
 * @returns {boolean} true if user is scrolling down, false if scrolling up or at top
 */
function useScroll() {
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      // Try ScrollArea first, then fallback to window
      const scrollContainer = document.querySelector(
        '[data-radix-scroll-area-viewport]'
      );
      const currentScrollY = scrollContainer?.scrollTop ?? window.scrollY;

      // Only show footer when scrolling down and past 100px
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setIsScrollingDown(true);
      } else if (
        currentScrollY < lastScrollY.current ||
        currentScrollY <= 100
      ) {
        setIsScrollingDown(false);
      }

      lastScrollY.current = currentScrollY;
    };

    // Listen to ScrollArea if it exists
    const scrollContainer = document.querySelector(
      '[data-radix-scroll-area-viewport]'
    );
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll, {
        passive: true,
      });
      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return isScrollingDown;
}

export default useScroll;
